import Vue from 'vue';
import {LoadingBar} from 'iview';
import Util from '../../libs/util';
import VueRouter from 'vue-router';
import store from '../store/index';
import {routers} from './router';

import {isMobile} from '../../libs/ismobile';

Vue.use(VueRouter);
// 路由配置
const RouterConfig = {
    // mode: 'history',
    routes: routers
};
export const router = new VueRouter(RouterConfig);

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

let go = function (name, next) {
    let resOK = !!store.state.user.user;
    if (resOK) {
        let resNames = store.state.user.resKeys;
        if (store.state.user.isROOT || resNames.has(name) || name === "explain" || name === "m_monitor" || name === "set_pwd_page" || name === "set_mobile_page" || name === "wx_qr") {
            next();
        } else {  // 无权限  进入403
            next({
                replace: true,
                name: 'error-403'
            });

        }
    } else if (name.indexOf('error') !== 0) {
        Util.getAuth().then(() => {
            go(name, next);
        })
    }

}

router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/f/')) {
        location.href = Util.baseURL + to.path;
    }
    //配置加载进度条
    LoadingBar.config({
        color: '#2d8cf0',
        failedColor: '#ff9900',
        height: 3
    });
    LoadingBar.start();//开始加载进度条
    Util.title(to.meta.title, router.app);
    let token = localStorage.getItem("token");
    // console.log('===== 路由守卫调试 =====');
    // console.log('访问路径：', to.path); // 确认是 /wx
    // console.log('匹配的路由name：', to.name); // 确认是否是 wx_qr（关键！）
    // console.log('是否判定为手机端：', isMobile()); // 确认设备类型
    // console.log('localStorage token：', localStorage.getItem("token"));
    if (isMobile()) { // 手机端
        if (to.name === "wx_qr") {
            next();
        }
        else if (to.name === 'm_login') {
            next();
        } else if ((!token || token === 'null') || to.name === 'login') {
            next({
                replace: true,
                name: 'm_login'
            });
        } else if (to.name === 'home_index') {
            next({
                // replace: true,
                name: 'm_home'
            });
        } else if (to.name === "m_home") {
            next();
        } else {
            go(to.name, next)
        }
        LoadingBar.finish();
    }
    else { // 网页端
        if (to.name === 'login' || to.name === 'set_pwd_page' || to.name === 'set_mobile_page') {
            next();
        } else if (to.name.startsWith('error')) {
            next();
        } else if (!token || token === 'null') { // 应该跳转对应的login、
            next({
                replace: true,
                name: 'login'
            });
        } else if (to.name === 'home_index') {
            next();
        } else {
            go(to.name, next)
        }

    }
});

router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
    LoadingBar.finish();
    window.scrollTo(0, 0);
    let moniteringFlag = false;
    store.state.app.pageOpenedList.map((route) => {
        if (route.name === 'monitor' || route.name === 'lift-list') {
            moniteringFlag = true;
        }
    });
});
